import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

export const getMasterReviewer = (
  pageSize,
  pageNumber,
  fname,
  lname,
  idCard,
  accountType,
  expertiseType
) => {
  const url = `${API_ROOT}/portal/reviewer/${pageNumber}/${pageSize}?fname=${fname || ''}&lname=${
    lname || ''
  }&idCard=${idCard || ''}&accountType=${accountType || ''}&expertiseType=${expertiseType || ''}`
  return doGet(url)
}

export const getMasterReviewerFileById = (id) => {
  const url = `${API_ROOT}/portal/reviewer/${id}/download`
  return doDownload(url)
}

export const saveMasterReviewer = (request) => {
  const url = `${API_ROOT}/portal/reviewer`
  return doPost(url, request)
}

export const updateMasterReviewer = (id, request) => {
  const url = `${API_ROOT}/portal/reviewer/${id}`
  return doPut(url, request)
}

export const deleteMasterReviewer = (id) => {
  const url = `${API_ROOT}/portal/reviewer/${id}`
  return doDelete(url)
}

export const getMasterReviewerReport = (request) => {
  const url = `${API_ROOT}/files/download/master-reviewer-report`
  return doPostDownload(url, request)
}
